import axiosInstance from "../axios";
const { REACT_APP_LOGIN_API_BASEURL } =
  process.env;

export const categoryService = {
  getCategories: () => {
    return axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/categories`);
  }
};